<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'VRadioEditor',
  extends: compoment
}
</script>
